import { axiosInstance } from '../axios/axiosConfig';

const controller = 'trainers';

export const trainerRegistration = async (formData) => {
    try {
        const response = await axiosInstance.post(`/${controller}/TrainerRegistration`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getRealTimeTrainers = async (body, query) => {
    try {
        const response = await axiosInstance.post(`/${controller}/GetAllRealTimeTrainer`, body, { params: { ...query } });
        return response;
    } catch (error) {
        throw error.response?.data || error.message;
    }
}

export const getRatingDetailsByTrainerId = async (body, trainerId) => {
    try {
        const response = await axiosInstance.post(`/${controller}/${trainerId}/ratings`, body);
        return response;
    } catch (error) {
        throw error.response?.data || error.message;
    }
}

export const createRatingForTrainer = async (body, trainerId) => {
    try {
        const response = await axiosInstance.post(`/${controller}/${trainerId}/rating`, body);
        return response;
    } catch (error) {
        throw error.response?.data || error.message;
    }
}